import React from 'react'
// libs
import { useDispatch, useSelector } from 'react-redux'
// hooks
import { useModalData } from 'hooks/index'
// store
import { setAccumulatedFormData } from 'store/reducers/accumulatedForms'
// components
import Modal from 'components/UI/Modal'
import Header from 'components/UI/Modal/Header'
import SetDocumentDescriptionForm from './SetDocumentDescriptionForm'
// constants
import { Forms, Modals } from 'constants/index'
// types
import { RootState } from 'store/store'
// utils
import get from 'lodash/get'

const SetDocumentDescriptionModal = () => {
  const dispatch = useDispatch()

  const {
    hideModal,
    modalData: { key, name, width, isOpen }
  } = useModalData({ modalType: Modals.SET_DOCUMENT_DESCRIPTION_MODAL })

  const accountForm = useSelector((state: RootState) => state.accumulatedForms[Forms.ACCUMULATED_CREATE_ACCOUNT])

  const handleHideModal = () => hideModal()

  const handleSubmit = (data) => {
    dispatch(
      setAccumulatedFormData({
        type: Forms.ACCUMULATED_CREATE_ACCOUNT,
        data: {
          documents: {
            ...get(accountForm, 'documents', {}),
            [key]: data
          }
        }
      })
    )

    handleHideModal()
  }

  const getInitialValues = () => {
    return {
      description: get(accountForm, `documents[${key}].description`)
    }
  }

  return (
    <Modal hideModal={handleHideModal} isOpen={isOpen} width={width}>
      <Header handleClearClick={handleHideModal}>{name} Content</Header>
      <SetDocumentDescriptionForm
        licenceType={name}
        onSubmit={handleSubmit}
        onCancelClick={handleHideModal}
        initialValues={getInitialValues()}
      />
    </Modal>
  )
}

export default SetDocumentDescriptionModal
